module.exports = __webpack_public_path__ + "img/index_glzx1.1848ba1b.png";